var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.275 20.0771C9.225 19.9174 7.5 19.1108 6.1 17.6573C4.7 16.2038 4 14.4788 4 12.4823C4 11.2524 4.29583 10.0945 4.8875 9.00835C5.47917 7.92224 6.30833 7.03578 7.375 6.34897L8.45 7.37918C7.51667 7.90626 6.79167 8.62901 6.275 9.54741C5.75833 10.4658 5.5 11.4441 5.5 12.4823C5.5 14.0795 6.05 15.4611 7.15 16.6271C8.25 17.7931 9.625 18.4639 11.275 18.6396V20.0771ZM12.775 20.0771V18.6396C14.4417 18.4479 15.8167 17.7731 16.9 16.6151C17.9833 15.4571 18.525 14.0795 18.525 12.4823C18.525 10.7413 17.8958 9.2679 16.6375 8.06199C15.3792 6.85609 13.8417 6.25314 12.025 6.25314H11.525L13.025 7.69064L11.95 8.72085L8.625 5.53439L11.95 2.34793L13.025 3.37814L11.525 4.81564H12.025C14.2583 4.81564 16.15 5.56234 17.7 7.05574C19.25 8.54915 20.025 10.358 20.025 12.4823C20.025 14.4788 19.3292 16.2038 17.9375 17.6573C16.5458 19.1108 14.825 19.9174 12.775 20.0771Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestart);
export default __webpack_public_path__ + "static/media/restart.ef1c4229c2c80a25d64092865c7d357e.svg";
export { ForwardRef as ReactComponent };